import { Polygon, Marker } from '@react-google-maps/api';
import { typeCoords } from '@monorepo/models';
import React, { useState } from 'react';

export type BlockPolygonProps = {
  path: typeCoords[];
  color: string;
  isDarkMode: boolean;
  onClick: () => void;
  label: string;
  center: typeCoords;
  strokeColor?: string;
};

const GeriatricBlockPolygon: React.FC<BlockPolygonProps> = ({ path, color, isDarkMode, onClick, label, center, strokeColor }) => {
  const [hover, setHover] = useState(false);

  return (
    <>
      <Polygon
        path={path}
        onClick={onClick}
        onMouseOver={() => setHover(true)}
        onMouseOut={() => setHover(false)}
        options={{
          clickable: true,
          fillColor: color,
          fillOpacity: hover ? 0.9 : 0.7,
          strokeColor: strokeColor || color,
          strokeOpacity: 1,
          strokeWeight: 3,
          zIndex: 1,
        }}
        // @ts-ignore
        style={{ transition: 'fill 0.3s, stroke 0.3s' }}
      />
      {label && (
        <Marker
          position={center}
          options={{
            label: {
              text: label,
              color: 'black',
              fontFamily: 'Arial, Helvetica, sans-serif',
              fontSize: '16px',
              fontWeight: 'bold',
              className: 'territory-label'
            },
            icon: {
              path: window.google?.maps?.SymbolPath?.CIRCLE || 0,
              scale: 16,
              fillColor: 'white',
              fillOpacity: 1,
              strokeColor: 'black',
              strokeWeight: 3,
            },
          }}
        />
      )}
    </>
  );
};

export default GeriatricBlockPolygon;
